import {
  RateLimitedExceptionpvooiq68cx8k as RateLimitedException,
  ConnectionException1wjs7wwnknnfm as ConnectionException,
  HttpMethod_GET_getInstance1esunrp6hgoe5 as HttpMethod_GET_getInstance,
  ServerUnavailableException3tforh8zfc9yr as ServerUnavailableException,
} from './fetch.mjs';
import {
  Duration__times_impl_sfuzvp2hsmf7rscmq7h as Duration__times_impl_sfuzvp,
  Duration__plus_impl_yu9v8fuwslfu377uhg as Duration__plus_impl_yu9v8f,
  Duration5ynfiptaqcrg as Duration,
  Duration__times_impl_sfuzvp17qfsy828s7xa as Duration__times_impl_sfuzvp_0,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  toDurationba1nlt78o6vu as toDuration_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { coerceAtMost31oazapy1u82u as coerceAtMost } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  withContext3b6r4oljqqy1b as withContext,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { delayp0o4nsccwai as delay } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { Default_getInstancee1f46otjvolq as Default_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { printStackTrace214c8iyv3cpiv5 as printStackTrace2 } from './debugger.js.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_0,
  Element2gr7ezmxqaln7 as Element,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toLongOrNullutqivezb0wx1 as toLongOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { httpHeaders3s629sxokj9k6 as httpHeaders } from './fetch.js.mjs';
import { Companion_getInstance1gp5vi6mchd0u as Companion_getInstance_0 } from './HttpFetcher.mjs';
import { Default_getInstance27jodt8hd1bac as Default_getInstance_0 } from './debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function release($this) {
  $this.retryAt_1.set_value_v1vabv_k$(null);
  $this.gate_1.set_permit_ko68xv_k$(true);
}
function scheduleRetry($this, cause) {
  var ceiling = $this.nextRetry_1;
  var tmp0_safe_receiver = cause instanceof RateLimitedException() ? cause : null;
  var after = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.retryAfter_1;
  var tmp;
  var tmp_0 = after;
  if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
    tmp = Duration__times_impl_sfuzvp(ceiling, $this.random_1.nextDouble_s2xvfg_k$());
  } else {
    tmp = Duration__plus_impl_yu9v8f(after, Duration__times_impl_sfuzvp($this.baseRetry_1, $this.random_1.nextDouble_s2xvfg_k$()));
  }
  var wait = tmp;
  $this.scheduleGeneration_1 = $this.scheduleGeneration_1 + 1 | 0;
  var generation = $this.scheduleGeneration_1;
  $this.retryAt_1.set_value_v1vabv_k$($this.clock_1.now_2cba_k$().plus_tegsqz_k$(wait));
  $this.nextRetry_1 = coerceAtMost(new (Duration())(Duration__times_impl_sfuzvp_0(ceiling, 2)), new (Duration())($this.maxRetry_1)).rawValue_1;
  $this.gate_1.set_permit_ko68xv_k$(false);
  var tmp_1 = $this.scope_1();
  launch(tmp_1, VOID, VOID, ConnectivityGate$scheduleRetry$slambda($this, wait, generation));
}
function ConnectivityGate$_init_$slambda_l7pv2u() {
  return constructCallableReference((ms, $completion) => orPromise($completion, function *($completion) {
    yield* delay(ms, $completion);
    return Unit_instance;
  }), 1);
}
function ConnectivityGate$_init_$lambda_ir2y53() {
  return get_AppScope();
}
function ConnectivityGate$scheduleRetry$slambda(this$0, $wait, $generation) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $(this$0.delay_1(_Duration___get_inWholeMilliseconds__impl__msfiry($wait), $completion), $completion);
    var tmp;
    if (!($generation === this$0.scheduleGeneration_1)) {
      return Unit_instance;
    }
    release(this$0);
    return Unit_instance;
  }), 1);
}
var ConnectivityGateClass;
function ConnectivityGate() {
  if (ConnectivityGateClass === VOID) {
    class $_0 {
      constructor(clock, delay, random, scope) {
        clock = clock === VOID ? System_instance : clock;
        var tmp;
        if (delay === VOID) {
          tmp = ConnectivityGate$_init_$slambda_l7pv2u();
        } else {
          tmp = delay;
        }
        delay = tmp;
        random = random === VOID ? Default_getInstance() : random;
        var tmp_0;
        if (scope === VOID) {
          tmp_0 = ConnectivityGate$_init_$lambda_ir2y53;
        } else {
          tmp_0 = scope;
        }
        scope = tmp_0;
        this.clock_1 = clock;
        this.delay_1 = delay;
        this.random_1 = random;
        this.scope_1 = scope;
        this.gate_1 = new (WaitGate())(true);
        var tmp_1 = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        tmp_1.baseRetry_1 = toDuration(10, DurationUnit_SECONDS_getInstance());
        var tmp_2 = this;
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        tmp_2.maxRetry_1 = toDuration(5, DurationUnit_MINUTES_getInstance());
        this.nextRetry_1 = this.baseRetry_1;
        this.retryAt_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.scheduleGeneration_1 = 0;
      }
      *run_azsczg_k$(tag, action, $completion) {
        while (true) {
          yield* this.gate_1.await_7ugp35_k$($completion);
          try {
            var r = yield* $(action($completion), $completion);
            this.nextRetry_1 = this.baseRetry_1;
            return r;
          } catch ($p) {
            if ($p instanceof ConnectionException()) {
              var e = $p;
              printStackTrace2(e);
              if (this.retryAt_1.get_value_j01efc_k$() == null) {
                scheduleRetry(this, e);
              }
            } else {
              throw $p;
            }
          }
        }
      }
    }
    initMetadataForClass($_0, 'ConnectivityGate', ConnectivityGate, VOID, VOID, [2]);
    ConnectivityGateClass = $_0;
  }
  return ConnectivityGateClass;
}
var WaitGateClass;
function WaitGate() {
  if (WaitGateClass === VOID) {
    class $ {
      constructor(permit) {
        permit = permit === VOID ? false : permit;
        this.permit_1 = permit;
        this.continuations_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      set_permit_ko68xv_k$(value) {
        this.permit_1 = value;
        if (value) {
          var resuming = toList(this.continuations_1);
          this.continuations_1.clear_j9egeb_k$();
          var _iterator__ex2g4s = resuming.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var continuation = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
            continuation.resumeWith_rk9gbt_k$(tmp$ret$1);
          }
        }
      }
      *await_7ugp35_k$($completion) {
        if (this.permit_1)
          return Unit_instance;
        else {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.initCancellability_shqc60_k$();
            var it = cancellable;
            this.continuations_1.add_utx5q5_k$(it);
            it.invokeOnCancellation_kffkqp_k$((_unused_var__etf5q3) => {
              this.continuations_1.remove_cedx0m_k$(it);
              return Unit_instance;
            });
            return cancellable.getResult_fck196_k$();
          });
          return Unit_instance;
        }
      }
    }
    initMetadataForClass($, 'WaitGate', WaitGate, VOID, VOID, [0]);
    WaitGateClass = $;
  }
  return WaitGateClass;
}
var ConnectivityClass;
function Connectivity() {
  if (ConnectivityClass === VOID) {
    class $ {
      constructor() {
        Connectivity_instance = this;
        this.noConnectivityCodes_1 = setOf([502, 503]);
        this.tooMuchCodes_1 = setOf([420, 429]);
        this.stopConnectivityCodes_1 = plus(this.noConnectivityCodes_1, this.tooMuchCodes_1);
        this.fetchGate_1 = new (ConnectivityGate())();
        this.lastConnectivityIssueCode_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(0);
      }
    }
    initMetadataForObject($, 'Connectivity');
    ConnectivityClass = $;
  }
  return ConnectivityClass;
}
var Connectivity_instance;
function Connectivity_getInstance() {
  if (Connectivity_instance === VOID)
    new (Connectivity())();
  return Connectivity_instance;
}
function *suppressConnectivityIssues(action, $completion) {
  var tmp = new (ConnectivityIssueSuppress())();
  return yield* withContext(tmp, suppressConnectivityIssues$slambda(action), $completion);
}
function *connectivityFetch(url, method, headers, body, $completion) {
  method = method === VOID ? HttpMethod_GET_getInstance() : method;
  var tmp;
  if (headers === VOID) {
    tmp = connectivityFetch$slambda();
  } else {
    tmp = headers;
  }
  headers = tmp;
  var tmp_0 = Connectivity_getInstance().fetchGate_1;
  var tmp_1 = method.toString() + ' ' + url;
  return yield* runRequest(tmp_0, tmp_1, connectivityFetch$slambda_0(url, method, headers, body), $completion);
}
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
var ConnectivityIssueSuppressClass;
function ConnectivityIssueSuppress() {
  if (ConnectivityIssueSuppressClass === VOID) {
    class $ {
      constructor() {
        this.key_1 = Key_instance;
      }
      get_key_18j28a_k$() {
        return this.key_1;
      }
    }
    protoOf($).get_y2st91_k$ = get;
    protoOf($).fold_j2vaxd_k$ = fold;
    protoOf($).minusKey_9i5ggf_k$ = minusKey;
    protoOf($).plus_s13ygv_k$ = plus_0;
    initMetadataForClass($, 'ConnectivityIssueSuppress', ConnectivityIssueSuppress, VOID, [Element()]);
    ConnectivityIssueSuppressClass = $;
  }
  return ConnectivityIssueSuppressClass;
}
function *runRequest(_this__u8e3s4, tag, request, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  if (!($completion.get_context_h02k06_k$().get_y2st91_k$(Key_instance) == null))
    return yield* runRequest$attempt(request, $completion);
  return yield* _this__u8e3s4.run_azsczg_k$(tag, runRequest$slambda(tag, request), $completion);
}
function connectivityFailure(_this__u8e3s4) {
  return Connectivity_getInstance().tooMuchCodes_1.contains_aljjnj_k$(_this__u8e3s4.get_status_jnf6d7_k$()) ? RateLimitedException().new_com_lightningkite_kiteui_RateLimitedException_gwi8l4_k$('Status code ' + _this__u8e3s4.get_status_jnf6d7_k$(), retryAfter(_this__u8e3s4)) : ServerUnavailableException().new_com_lightningkite_kiteui_ServerUnavailableException_3w7x0a_k$('Status code ' + _this__u8e3s4.get_status_jnf6d7_k$());
}
function get_serverAnswered(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ServerUnavailableException()) {
    tmp = true;
  } else {
    tmp = _this__u8e3s4 instanceof RateLimitedException();
  }
  return tmp;
}
function retryAfter(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.get_headers_ef25jx_k$().get('Retry-After');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp0_safe_receiver) ? tmp0_safe_receiver : THROW_CCE()));
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toLongOrNull(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (tmp2_safe_receiver >= 0n) {
      tmp_1 = tmp2_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  var tmp3_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp3_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp_2 = toDuration_0(tmp3_safe_receiver, DurationUnit_SECONDS_getInstance());
  }
  return tmp_2;
}
function suppressConnectivityIssues$slambda($action) {
  return constructCallableReference(($this$withContext, $completion) => orPromise($completion, function *($completion) {
    return yield* $($action($completion), $completion);
  }), 1);
}
function connectivityFetch$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return httpHeaders();
  }), 0);
}
function connectivityFetch$slambda_0($url, $method, $headers, $body) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return yield* Companion_getInstance_0().default_1.fetch$default_g82v7y_k$($url, $method, yield* $($headers($completion), $completion), $body, VOID, VOID, $completion);
  }), 0);
}
function *runRequest$attempt($request, $completion) {
  var response = yield* $($request($completion), $completion);
  if (Connectivity_getInstance().stopConnectivityCodes_1.contains_aljjnj_k$(response.get_status_jnf6d7_k$())) {
    Connectivity_getInstance().lastConnectivityIssueCode_1.set_value_v1vabv_k$(response.get_status_jnf6d7_k$());
    throw connectivityFailure(response);
  }
  return response;
}
function runRequest$slambda($tag, $request) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    try {
      tmp = yield* /*#__NOINLINE__*/runRequest$attempt($request, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ConnectionException()) {
        var e = $p;
        if (get_serverAnswered(e))
          throw e;
        Default_getInstance_0().warn_e3mr9o_k$(['Immediate retry on ' + $tag + ' after ' + e.message]);
        var tmp_1;
        try {
          tmp_1 = yield* /*#__NOINLINE__*/runRequest$attempt($request, $completion);
        } catch ($p_0) {
          var tmp_2;
          if ($p_0 instanceof ConnectionException()) {
            var again = $p_0;
            if (!get_serverAnswered(again)) {
              Connectivity_getInstance().lastConnectivityIssueCode_1.set_value_v1vabv_k$(0);
            }
            throw again;
          } else {
            throw $p_0;
          }
        }
        tmp_0 = tmp_1;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }), 0);
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  Connectivity_getInstance as Connectivity_getInstance3vnm26551dbr1,
  connectivityFetch as connectivityFetch17pa0p5vdf435,
  suppressConnectivityIssues as suppressConnectivityIssues31dqegaooooyg,
};
//endregion

//# sourceMappingURL=fetch-connectivity.mjs.map
